import styled from '@emotion/styled';

import variables from 'theme/styles/vars';

export default styled.div`
	.layout-container {
		display: flex;
		justify-content: space-between;
		align-items: center;

		.box-content {
			width: 48%;
		}

		.box-image {
			width: 50%;
		}
	}

	@media all and (max-width: ${variables.mobileL}) {
		.layout-container {
			display: block;
			width: 100%;
            display: flex;
            flex-flow: column wrap;
            align-items: cetner;

			.box-content {
				padding: 1em 0;
				width: 90%;
                
			}

			.box-image {
				width: 100%;
			}
		}
	}
`;
